/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Home_GreetingInputs */

const en_home_greeting = /** @type {(inputs: Home_GreetingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hello, ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Hello, {name}" |
*
* @param {Home_GreetingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_greeting = /** @type {((inputs: Home_GreetingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_GreetingInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_greeting(inputs)
});